/**
 * WARNING: This component is auto-generated by the build script in the parent directory.
 * Do not edit this file, as any changes will be overwritten. Instead, edit the template and
 * svg files to make changes
 */
import React from "react";
import classNames from "classnames";
import { IIconProps, IconSize } from "../types";

const NewFeatures = (props: IIconProps): React.ReactElement => {
  const { className, size = IconSize.Medium, ...rest } = props;
  const iconClass = classNames("kl-icon", `kl-icon--${size}`, className);
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    <path
      fillRule="evenodd"
      d="M4.47 7h15.06c.26 0 .47.199.47.444v3.111c0 .246-.21.445-.47.445H4.47a.458.458 0 01-.47-.445v-3.11C4 7.198 4.21 7 4.47 7zM19 12H5v7.579c0 .377.158.738.44 1.005.28.266.662.416 1.06.416h11c.398 0 .78-.15 1.06-.416.282-.267.44-.628.44-1.005v-7.58z"
      clipRule="evenodd"
      opacity={0.6}
    />,
    <path
      fillRule="evenodd"
      d="M12 4.947C12.56 3.969 13.607 3 14.986 3c.534 0 1.046.21 1.424.586a1.993 1.993 0 010 2.828c-.378.375-.89.586-1.424.586H13v14h-2V7H9.014c-.534 0-1.046-.21-1.424-.586a1.993 1.993 0 010-2.828C7.968 3.21 8.48 3 9.014 3c1.379 0 2.427.969 2.986 1.947zm-3.752.813c.203.202.479.315.766.315 1.11 0 1.997 0 2.49-.026-.207-.742-1.089-2.125-2.49-2.125-.287 0-.563.114-.766.315a1.072 1.072 0 000 1.521zm6.738.315c.287 0 .563-.113.766-.315a1.072 1.072 0 000-1.52 1.087 1.087 0 00-.766-.316c-1.401 0-2.283 1.383-2.49 2.125.493.026 1.38.026 2.49.026z"
      clipRule="evenodd"
    />,
  );
};

export default NewFeatures;
